// import Autosuggest from 'react-autosuggest'
import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { chain, includes } from 'lodash'
import moment from 'moment'
import config from '../../config'
import Loader from 'react-loader'
import CSSModules from 'react-css-modules'
import format from '../../helpers/format'
import { asyncConnect } from 'redux-async-connect'
import { SlideDown } from 'react-slidedown'

// import Helmet from 'react-helmet'
import container from '../../helpers/container'
import convert from '../../helpers/convert'
import analytics from '../../helpers/analytics'
import Modal from 'react-modal'
import { Row, Col } from 'react-flexbox-grid'

const CompanySectors = require('../../data/CompanySectors.json')
const FundFamilyPetitions = require('../../data/FundFamilyPetitions.json')

import {
  // Score,
  ContainerDivs,
  CompanyProfileModal,
  Grade,
  Link,
  LinkIcon,
  Chart,
  FlaggedFund,
  SocialButtons,
  FundName,
  Returns,
  InlineSignup,
  IyvScorecard,
} from '../../components'
import ReactTooltip from 'react-tooltip'

const Styles = require('./Fund.css')
const MaxPerPage = 5
import * as searchActions from 'redux/modules/search'

function mapFundHoldings(fHoldings){
  const fHoldingsMap = {}
  fHoldings.forEach((fholding)=>{
    fHoldingsMap[fholding.db_holding_id] = fholding
  })
  return fHoldingsMap
}
function filterHoldings(fHoldingsMap, holdings, filterFn){
  return chain(holdings)
  .filter(filterFn)
  .sortBy((o)=>{
    return fHoldingsMap[o.id].market_value * -1
  })
  // .take(10)
  .value()
}

@connect(
  state => ({ result: state.shareClass.result,
    loading: state.shareClass.loading, loaded: state.shareClass.loaded, error: state.shareClass.error }),
  searchActions)


@asyncConnect([{
  deferred: true, // need otherwise cient navigate is blocked until the page is loaded
  promise: ({params, store: {dispatch, getState}}) => {
    return dispatch(searchActions.shareClassDetails(params.fundId, params.investmentVehicleId))
  }
}])
@CSSModules(Styles, {allowMultiple:true})
export default class Fund extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.object,
  }
  static contextTypes =  {
    router: PropTypes.object.isRequired
  }
  constructor(props) {
    super(props)
    this.state = {
      openModal: false,
      producersPage: 1,
      banksPage: 1,
      consumersPage: 1,
      viewMore: false,
      openModalShown: false,
    }
  }
  componentWillMount() {
    this._mounted = true
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
    const { fundId, investmentVehicleId } = this.props.params
    analytics.event(analytics.eventLoadFund(fundId, investmentVehicleId))
  }

  componentWillUnmount() {
    this._mounted = false
  }

  // deprecated
  handleScroll = () => {
    if (!this._mounted) { return }
    if (!this.props.result){ return }
    const { shareClass } = this.props.result
    const name = shareClass.fund_family_name
    const scrollTop = event.srcElement.body.scrollTop
    const isSelectFamily = config.familyFunds.find((fam) => fam.name === name)
    const hasScrolled = scrollTop > window.innerHeight
    // if user has scrolled, and modal is not already shown, and it's one of
    // the selected families: open the modal via set state
    if (shareClass && hasScrolled && !this.state.openModalShown &&
        isSelectFamily) {
      this.setState({openModal: true, openModalShown: true})
    }
  }

  // need this solution since asyncConnect and anchor links does not play nice
  scrollTo = (id) =>{
    return () =>{
      const ele = document.getElementById(id)
      window.scrollTo(ele.offsetLeft,ele.offsetTop)
    }
  }

  clickViewMore = () =>{
    this.setState({viewMore: !this.state.viewMore})
  }

  clickCloseModal = () =>{
    this.setState({openModal: !this.state.openModal})
  }

  increment = (incState) => {
    return () => {
      const newState = {}
      newState[incState] = this.state[incState] + 1
      this.setState(newState)
    }
  }

  holdingsCount = (count) => {
    if (count > 0) return format.number(count) + ' HOLDINGS'
    return ''
  }

  hasUssifBadge = (ussif) => {
    // true if fund gets ussif badge else false
    return convert.float(ussif) === 1.5
  }

  renderHoldings = (shareClass, fHoldingsMap, holdings, page, type) => {
    // if no holdings, return "no holdings" notice
    if (!holdings || holdings.length === 0) {
      return <div styleName='holdings-none'>NONE</div>
    }

    // icon images
    const iconPo = require('../../../static/images/icn-po.svg')
    const iconPp = require('../../../static/images/icn-pp.svg')
    const iconRb = require('../../../static/images/icn-rb.svg')
    const iconTb = require('../../../static/images/icn-tb.svg')
    const iconBf = require('../../../static/images/icn-bf.svg')
    const iconSy = require('../../../static/images/icn-sy.svg')
    const iconPoY = require('../../../static/images/icn-po-y.svg')
    const iconPpY = require('../../../static/images/icn-pp-y.svg')
    const iconRbY = require('../../../static/images/icn-rb-y.svg')
    const iconTbY = require('../../../static/images/icn-tb-y.svg')
    const iconBfY = require('../../../static/images/icn-bf-y.svg')
    const iconSyY = require('../../../static/images/icn-sy-y.svg')

    return chain(holdings)
    .take(page*MaxPerPage)
    .map( (holding,idx) =>{
      const flags = []
      const c = CompanySectors.data[holding.company_id]
      if (type === 'producers') {
        if (includes(c, 'is_sy_p')){ flags.push(['is_sy_p', iconSy, 'Soy producer']) }
        if (includes(c, 'is_bf_p')){ flags.push(['is_bf_p', iconBf, 'Cattle producer']) }
        if (includes(c, 'is_tb_p')){ flags.push(['is_tb_p', iconTb, 'Timber producer']) }
        if (includes(c, 'is_rb_p')){ flags.push(['is_rb_p', iconRb, 'Rubber producer']) }
        if (includes(c, 'is_pp_p')){ flags.push(['is_pp_p', iconPp, 'Paper/pulp producer']) }
        if (includes(c, 'is_po_p')){ flags.push(['is_po_p', iconPo, 'Palm oil producer']) }
      }
      if (type === 'consumers') {
        if (includes(c, 'is_sy_c')){ flags.push(['is_sy_c', iconSyY, 'Soy major consumer brand']) }
        if (includes(c, 'is_bf_c')){ flags.push(['is_bf_c', iconBfY, 'Cattle major consumer brand']) }
        if (includes(c, 'is_tb_c')){ flags.push(['is_tb_c', iconTbY, 'Timber major consumer brand']) }
        if (includes(c, 'is_rb_c')){ flags.push(['is_rb_c', iconRbY, 'Rubber major consumer brand']) }
        if (includes(c, 'is_pp_c')){ flags.push(['is_pp_c', iconPpY, 'Paper/pulp major consumer brand']) }
        if (includes(c, 'is_po_c')){ flags.push(['is_po_c', iconPoY, 'Palm oil major consumer brand']) }
      }
      return (
        <li key={idx} styleName='holding'>
          <div styleName='holding-name'>
            <CompanyProfileModal company_id={holding.company_id}>
              {idx+1}. {holding.security_name}
            </CompanyProfileModal>
            <div styleName='detail-icon-holding-wrap visible-sm visible-md visible-lg'>
              { /* one image per flag */
                flags.length > 0 ?
                  flags.map((flag)=>{
                    return (
                      <img
                        key={flag[0]}
                        styleName='detail-icon-holding'
                        src={flag[1]}
                        alt={flag[2]}
                        title={flag[2]}
                      />
                    )
                  })
                : null
              }
            </div>
          </div>
          <div styleName='holding-asset'>
            <span styleName='visible-sm visible-md visible-lg'>
              {format.perc(fHoldingsMap[holding.id].scaled_weighting)}
            </span>
            <span styleName='visible-xs holding-asset-mobile'>
              {format.perc(fHoldingsMap[holding.id].scaled_weighting)} of portfolio
            </span>
          </div>
          <div styleName='holding-invested'>
            <span styleName='visible-sm visible-md visible-lg'>
              {format.money(fHoldingsMap[holding.id].market_value, true,
                            shareClass.currency, true)}
            </span>
            <span styleName='visible-xs holding-asset-mobile'>
              {format.money(fHoldingsMap[holding.id].market_value, true,
                            shareClass.currency, true)} invested
            </span>
          </div>
          <div styleName='detail-icon-holding-wrap visible-xs'>
            { /* one image per flag */
              flags.length > 0 ?
                flags.map((flag)=>{
                  return (
                    <img
                      key={flag[0]}
                      styleName='detail-icon-holding'
                      src={flag[1]}
                      alt={flag[2]}
                      title={flag[2]}
                    />
                  )
                })
              : null
            }
          </div>
        </li>
      )
    })
    .value()
  }

  renderCompanies = (shareClass, fHoldingsMap, type, label, count, holdings, page, text) => {
    function hasMore(){
      if (!holdings || holdings.length === 0) {
        return false
      }
      return (page*MaxPerPage < holdings.length)
    }
    function moreCount(){
      if (!hasMore()) {
        return 0
      }
      const diff = holdings.length - (page * MaxPerPage)
      return (diff > MaxPerPage) ? MaxPerPage : diff
    }

    const poIcon = require('../../../static/images/icn-'+type+'.svg')
    const hasMoreButton = (hasMore(page,holdings) ? (
            <div
              styleName={'detail-more-'+type}
              onClick={this.increment(type+'Page')}
            >
              View next {moreCount()}<LinkIcon faclass='fa-angle-down' />
            </div>
          ) : null)

    count = convert.int(count)
    if( count === 0 ){
      return (
        <Col xs={12}>
          <div styleName='detail-holdings-wrapper'>
            <div styleName='detail-wrapper-empty'>
              <img
                styleName='detail-icon-empty'
                src={poIcon}
                alt='No holdings icon'/>
              <div styleName='detail-title-empty'>{label}</div>
              <div styleName='detail-holdings-empty'>0 HOLDINGS</div>
            </div>
          </div>
          <div styleName='detail-holdings-description-none'>
            {text}
          </div>
        </Col>
      )
    }
    return (
      <Col xs={12} styleName='detail-holdings-wrapper'>
        <div styleName={'detail-'+type}>
          <img styleName={'po-icon'} src={poIcon} alt={label}/>
          <div styleName='detail-title-holdings'>
            <div styleName={'detail-title-'+type}>
              {label}
            </div>
            <div styleName={'visible-sm visible-md visible-lg detail-holdings-count-'+type}>
              {this.holdingsCount(count)}
            </div>
          </div>
          <div styleName='detail-holdings-description'>
            {text}
          </div>
          <div styleName='visible-xs mobile-holdings-label'>
            {count} HOLDINGS
          </div>
          <SlideDown>
            <ul styleName='detail-holdings'>
              <li styleName='holding'>
                <div styleName='holding-name'>
                </div>
                <div styleName='visible-sm visible-md visible-lg holding-asset'>
                  % of portfolio
                </div>
                <div styleName='visible-sm visible-md visible-lg holding-invested'>
                  $ invested
                </div>
              </li>
              {this.renderHoldings(shareClass, fHoldingsMap, holdings, page,
                                   type)}
            </ul>
          </SlideDown>
        </div>
        {hasMoreButton}
      </Col>
    )
  }

  renderStats = (shareClass) => {
    function renderCol(type, entries, hasLine) {
      return (
        <Col xs={6} styleName={'col-'+type+'-wrapper'}>
          { /*  for each stat, it's either left or right, link or no link, and
                line or no line */
            entries.map((entry,idx) => {
              const showLine = hasLine && (idx !== entries.length-1)
              return (
                <div key={idx} styleName='col-label-value'>
                  <div styleName={'col-'+type}>
                    <div styleName='stats-label'>{entry.name}</div>
                    {entry.link ? (
                      <Link to={entry.link}>
                        <div styleName='stats-value-link'>
                          {entry.value}<LinkIcon />
                        </div>
                      </Link>
                    ) : (
                      <div styleName='stats-value'>{entry.value}</div>
                    )
                  }
                  </div>
                  {showLine ? <div styleName='col-line'/> : null}
                </div>
              )
            })
          }
        </Col>
      )
    }
    const dest = encodeURIComponent(shareClass.fund_family_name)

    return (
      <div styleName="stats">
        <div styleName="stats-inner">
          <Row styleName='stats-header'>
            <Col xs={6}>
              <div styleName='stats-title'>Mutual fund profile</div>
            </Col>
            {shareClass.grade_deforestation ? (
              <Col xs={6}>
                <div styleName='stats-score-label-score'>
                  <div styleName='stats-score-label'>Deforestation grade</div>
                    <div styleName='stats-score-wrapper'>
                      <Grade grade={shareClass.grade_deforestation} />
                    </div>
                </div>
              </Col>
            ) : null}
          </Row>
          <div styleName='line'/>
          <Row>
            { renderCol( 'left', [{name: 'Shareclass ticker', value:shareClass.ticker}], false ) }
            { renderCol('right', [{name: 'Data as of', value:moment(shareClass.date.slice(0,10)).format('D MMM YYYY')}], false) }
          </Row>
          <div styleName='line'/>
          <Row>
            { renderCol( 'left', [{name: 'Shareclass name', value:shareClass.name}], false ) }
            { renderCol( 'right', [{name: '% of fund assets screened', value:format.perc(shareClass.percent_rated) }], false ) }
          </Row>
          <div styleName='line'/>
          <Row>
            { renderCol( 'left', [{name: 'Shareclass type', value:format.legalType(shareClass.legal_type)}], false ) }
            { renderCol( 'right', [{name: 'Fund net assets', value:format.money(shareClass.fund_net_assets, true, shareClass.currency, true, 2)}], false ) }
          </Row>
          <div styleName='line'/>
          <Row>
            { renderCol( 'left', [{name: 'Fund family', link:config.routes.families+'?q='+dest, value:shareClass.fund_family_name}], false ) }
            { renderCol( 'right', [{name: 'Group', value:shareClass.category_group }], false ) }
          </Row>
          <div styleName='line'/>
          <Row>
            { renderCol( 'left', [{name: 'Country', value:format.market(shareClass.market)}], false ) }
            { renderCol( 'right', [{name: 'Currency', value:format.currencyCode(shareClass.currency)}], false ) }
          </Row>
          <div styleName='line'/>
          <Row>
            { renderCol( 'left', [{name: 'Sustainable investment', value:format.boolean(shareClass.ussif || "0")}], false ) }
            { renderCol( 'right', [{name: '', value: ''}], false ) }
          </Row>
          <div styleName='stats-totals'>
            <div styleName='stats-totals-header'>Totals</div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>
                Total flagged holdings for all deforestation categories (commodity producers, banks and lenders, and major consumer brands)
              </div>
              <div styleName='stats-total-value'>
                {format.number(shareClass.po_all_count)}
              </div>
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>
                Total % of fund assets flagged for all deforestation categories
              </div>
              <div styleName='stats-total-value'>
                {format.perc(shareClass.po_all_weight)}
              </div>
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>
                Total fund assets invested in flagged companies
              </div>
              <div styleName='stats-total-value'>
                {format.money(shareClass.po_all_asset, true,
                              shareClass.currency, true, 2)}
              </div>
            </div>

          </div>
        </div>
      </div>
    )
  }

  renderMoreButton = (portfolioDate, showDataAs) => {
    const label = (!this.state.viewMore ) ? 'View more info' : 'View less'
    const faclassUpDown = this.state.viewMore ? 'angle-up' : 'angle-down'
    return(
      <div styleName="view-more-wrapper">
        <div styleName="view-more" onClick={this.clickViewMore}>
          {label}
          <LinkIcon faclass={'fa-' + faclassUpDown} />
        </div>
        {showDataAs ? (
          <div styleName="view-more-data">
            DATA AS OF {moment(portfolioDate.slice(0,19)).format('D MMM YYYY')}
          </div>
        ) : null}
      </div>
    )
  }

  renderTakeAction = (shareClass) =>{
    function renderAction(info, button, link, log) {
      return (
        <div styleName='take-action-action'>
          <div styleName='take-action-info'>{info}</div>
          <div styleName='take-action-button-wrap'>
            <Link to={link} log={log} title={button}>
              <div styleName='take-action-button'>{button}</div>
            </Link>
          </div>
        </div>
      )
    }

    const { fund_id, investment_vehicle_id, ticker } = shareClass
    const fffRoute = config.links.fffFund + '/' + fund_id + 
      '/' + investment_vehicle_id + '/' + (ticker || '')

    return (
      <div styleName='take-action-wrap'>
        <div styleName='take-action-anchor' id='take-action'/>
        <div styleName='take-action'>
          <div styleName='take-action-inner'>
            <div styleName='take-action-header'>Take Action</div>
            <div styleName='take-action-line'/>
            {renderAction(
              'Call on U.S. investment firms to implement Deforestation ' +
              'and Land Grab-Free investment policies.',
              'SUPPORT THE PETITION', config.routes.petitions)}
            {renderAction(
              'Find top-graded funds that avoid deforestation-risk ' +
              'investments.',
              'FIND TOP-SCORING FUNDS', config.routes.clean)}
            {renderAction(
              'Use Fossil Free Funds to check this fund\'s fossil fuel ' +
              'investments and carbon footprint.',
              'CHECK FOR FOSSIL FUELS', fffRoute,
              analytics.eventToFFF(fund_id, investment_vehicle_id))}
          </div>
        </div>
      </div>
    )
  }

  renderMore = (shareClass, showDataAs) => {
    return (
      <div styleName="more-stats">
        {this.renderMoreButton(shareClass.date, true)}
        <SlideDown>
          {this.state.viewMore ? this.renderStats(shareClass) : null}
        </SlideDown>
      </div>
    )
  }

  renderUssifBadge = () => {
    const ussifLogo = require('../../../static/images/ussif-logo.png')
    const ussifAlt = 'Member of The Forum for Sustainable and Responsible' +
      'Investment icon'
    const linkTitle = 'US-SIF: Forum for Sustainable and Responsible Investment'
    return (
      <Row>
        <Col xs={12} styleName='ussif-wrapper'>
          <div styleName='ussif-badge-info'>
            <div styleName='ussif-info-title'>
              Member of the Forum for Sustainable and Responsible Investment
            </div>
            <div styleName='ussif-info-info'>
              This asset manager is a member of the Forum for Sustainable and Responsible Investment, a group advancing sustainable, responsible, and impact investing.
            </div>
            <div styleName='ussif-info-subtitle'>
              Learn more:&#160;
              <Link
                to={config.links.ussif}
                xstrong={true}
                title={linkTitle}
              >
                Forum for Sustainable and Responsible Investment
              </Link>
            </div>
          </div>
          <div styleName='ussif-img-wrap'>
            <img
              styleName='ussif-badge-img'
              src={ussifLogo}
              alt={ussifAlt}
            />
          </div>
        </Col>
      </Row>
    )
  }

  renderEngagementStatement = (shareClass) => {
    // filter engagement families from config to see if this family is
    // eligible for a statement box
    const engageFam = config.engagementFunds.find(
      (family) => family.name === shareClass.fund_family_name)
    const dffGrade = shareClass.grade_deforestation
    const hasEngageGrade = dffGrade === 1.5
    const isSri = convert.boolean(shareClass.socially_responsible_fund)
    // exit if it's not an engagement family
    if (!((engageFam || hasEngageGrade) && isSri)) {
      return null
    }
    // otherwise, check for SRI. only show the statement if family is engager,
    // has statement, and fund is SRI
    // encode URI since family names have special chars
    const dest = engageFam ? encodeURIComponent(engageFam.name) : ''
    return (
      <div styleName='engagement-statement-container'>
        <div styleName='engagement-statement-wrapper'>
          <div styleName='engagement-statement'>
            <div styleName='engagement-statement-grade-wrapper'>
              <Grade grade={1.5} large={true} />
            </div>
            <div styleName='engagement-statement-title'>
              Known Sustainability Engager
            </div>
            <p>
              Some sustainability-mandated funds actively engage the
              companies they own. Indeed, efforts by
              sustainability-focused investors whose funds are found on
              this site have been crucial to driving positive change in
              deforestation-risk sectors like palm oil. A number of asset
              managers are <strong>known sustainability engagers
              </strong>, and have taken actions such as filing&#160;
              <Link
                xstrong
                to={config.links.aysvote}
                title={'Vote Your Shares | As You Sow'}
              >
                shareholder resolutions
              </Link>
              &#160;asking for policy changes. Those asset managers deserve
              special acknowledgement - often, they are using their
              investments to make sure they have a voice at the table to
              call for real improvements in company behavior. We
              used&#160;
              <Link
                xstrong
                to={config.links.ceres}
                title={'Ceres Shareholder Resolution Database'}
              >
                data collected by Ceres
              </Link>
              &#160;to identify asset managers that have filed
              shareholder resolutions on deforestation, climate change,
              or other environmental issues. If a fund owns companies we
              screen for, but the family is a known filer of
              deforestation or environmental-related shareholder
              resolutions, it earns a special engagement score.&#160;
              <Link
                xstrong={true}
                to={config.routes.faq+'#7'}
                title={'FAQs | Deforestation Free Funds'}
              >
                Read more about our deforestation grades.
              </Link>
            </p>
            { /* if there is a list of companies filed at */
              engageFam.filedAt ? (
                <p>
                  {engageFam.name} has filed deforestation or
                  other climate-change related shareholder resolutions
                  at <strong>{engageFam.filedAt}</strong>&#160;
                <Link
                  xstrong
                  to={config.links.ceres}
                  title='Ceres Shareholder Resolutions Database'
                >
                  See the resolutions<LinkIcon />
                </Link>
                </p>
              ) : null
            }
            { /* if there is an engagement statement */
              engageFam.statement ? (
                <div>
                  <div styleName='engagement-statement-title'>
                    {engageFam.name} submitted a statement
                    describing their engagement efforts:
                  </div>
                  <blockquote styleName='engagement-statement-quote'>
                    {engageFam.statement}
                  </blockquote>
                </div>
              ) : null
            }
          </div>
        </div>
      </div>
    )
  }

  renderGraphicBanner = () => {
    return (
      <div styleName='banner-wrap'>
        <div styleName='banner'>
          <div styleName='banner-inner'>
            <div styleName='banner-taglines'>
              <div>
                <div styleName='banner-tagline'>
                  LET'S USE OUR
                </div>
              </div>
              <div>
                <div styleName='banner-tagline'>
                  PERSONAL ECONOMIC POWER
                </div>
              </div>
              <div>
                <div styleName='banner-tagline'>
                  TO DEFUND DEFORESTATION.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    // it no results, show a loader
    // else, if results, but no fund found, redirect to the 404 page
    if (!this.props.result) {
      return (
        <div styleName='main'>
          <Loader options={{scale: 0.70, top:'2.0rem'}} loaded={false} />
        </div>
      )
    } else if (this.props.result && (!this.props.result.fund ||
                                     !this.props.result.shareClass)) {
      this.context.router.push(config.routes.notFound)
      return (
        <div styleName='main'>
          <Loader options={{scale: 0.70, top:'2.0rem'}} loaded={false} />
        </div>
      )
    }

    function renderGradeBox(){
      // filter engagmentFamilies - if family returned, this shareclass
      // offered by engager
      const isEngagefam = config.engagementFunds.find(
        (family) => family.name === shareClass.fund_family_name)
      // only show the notice if both engager and also SRI fund
      // (e.g. no non-SRI engagers)
      const isSri = convert.boolean(fund.socially_responsible_fund)
      const getsEngagementNotice = isEngagefam && isSri
      // encode URI since family names have special chars
      const dest = isEngagefam ? encodeURIComponent(isEngagefam.name) : ''
      const letterGrade = format.score(fund.grade_deforestation)
      const sfGrade = letterGrade === 'N/A' ? 'NA' : letterGrade

      const descriptions = {
        A: 'No holdings flagged for our deforestation screens. Assigned a grade of A.',
        E: 'Err-e',
        B: 'Fund is invested in deforestation-risk banks and lenders and/or major consumer brands, but no holdings flagged for our deforestation-risk agricultural commodity producer/trader screen. Assigned a grade of B.',
        C: 'Fund is invested in deforestation-risk agricultural commodity producer/traders, below the threshold of 0.5%. Assigned a grade of C.',
        D: 'Fund is invested in deforestation-risk agricultural commodity producer/traders, above the threshold of 0.5% and below 1.5%. Assigned a grade of D.',
        F: 'Fund is invested in deforestation-risk agricultural commodity producer/traders, above the threshold of 1.5%. Assigned a grade of F.',
        NA: 'Error',
      }
      const description = descriptions[sfGrade]

      return (
        <div styleName='grade-snapshot'>
          { /* either show an engagement grade notice, or a letter grade */
            getsEngagementNotice ? (
              <div styleName='grade-engagement'>
                <div styleName='grade-intro'>
                  <span>
                    <strong>Engagement grade:</strong> This fund family
                    frequently engages the companies it
                    invests in to push for better behavior.
                  </span>
                  &#160;
                  <Link
                    strong
                    to={config.routes.families + '?q=' + dest}
                  >
                    <strong>
                      Learn more about engagement and socially responsible
                      investing.
                    </strong>
                  </Link>
                </div>
              </div>
            ) : (
              <div>
                <div styleName='grade-intro'>
                  <span>
                    <strong>Deforestation grade:</strong> {description}
                  </span>
                  <br/>
                  <Link strong to={config.routes.faq + '#7'}>
                    <strong>
                      How we track deforestation-risk investments
                      <LinkIcon />
                    </strong>
                  </Link>
                </div>
              </div>
            )
          }
          <div styleName='grade-wrapper'>
            <Grade grade={fund.grade_deforestation} large />
          </div>
          <ReactTooltip/>
          { /* <div styleName='update-notice'>
            <LinkIcon nospace={true} faclass='fa-info-circle'/>
            &nbsp;
            We've updated our grades!
            &nbsp;
            <Link
              to={config.routes.faq}
              strong={true}
              title='FAQ: Where does the "Deforestation Grade" come from?'
            >
              Learn more
              <LinkIcon/>
            </Link>
          </div> */ }
        </div>
      )
    }

    function getPerc(asset,totalAsset){
      asset = convert.int(asset)
      totalAsset = convert.int(totalAsset)
      if( totalAsset === 0 ){
        return 0
      }
      // return Math.round( asset/ totalAsset * 100 ) / 100
      return parseFloat((asset / totalAsset * 100).toFixed(2))
    }

    // images
    const producersIcon = require('../../../static/images/icn-producers.svg')
    const banksIcon = require('../../../static/images/icn-banks.svg')
    const consumersIcon = require('../../../static/images/icn-consumers.svg')

    const url = config.domain + this.props.location.pathname
    const { shareClass, fund } = this.props.result
    const { holdings, fundholdings, fund_family_name } = fund
    const name = fund.fund_legal_name
    const helmetTitle = 'Deforestation Free Funds results for ' + name
    const producerPerc = getPerc(fund.po_producer_asset, fund.fund_net_assets)
    const bankPerc =  getPerc(fund.po_financier_asset, fund.fund_net_assets)
    const consumerPerc =  getPerc(fund.po_consumer_asset, fund.fund_net_assets)
    const dffPerc =  getPerc(fund.po_all_asset, fund.fund_net_assets)
    const ownsProducers = fund.po_producer_asset > 0
    const ownsBanks = fund.po_financier_asset > 0
    const ownsConsumers = fund.po_consumer_asset > 0
    let color = 'cblack'
    if (!ownsProducers && !ownsBanks && !ownsConsumers) {
      color = 'cgreen'
    } else if (!ownsProducers && (ownsBanks || ownsConsumers)) {
      color = 'cltgreen'
    } else if (ownsProducers) {
      color = 'credorange'
    }
    const fHoldingsMap = mapFundHoldings(fundholdings)
    const producerHoldings = filterHoldings(fHoldingsMap, holdings, (o)=>{
      return o.is_po_producer
    })
    const financierHoldings = filterHoldings(fHoldingsMap, holdings, (o)=>{
      return o.is_po_financier
    })
    const consumerHoldings = filterHoldings(fHoldingsMap, holdings, (o)=>{
      return o.is_po_consumer
    })

    const familiesWithPetitions = Object.keys(FundFamilyPetitions.data)
    const hasPetition = familiesWithPetitions.indexOf(fund_family_name) >= 0
    const entry = hasPetition ? FundFamilyPetitions.data[fund_family_name] : null
    const petitionLink = entry ? entry[0] : null
    const petitionText = entry ? entry[1] : null
    const defaultCopy = 'Major fund managers invest millions into agricultural commodity producers and traders with business models that destroy the rainforest, and billions more into the banks and lenders that finance deforestation-risk producers, and the consumer brands that use these unsustainably-produced commodities in their products. Click below to learn more about the impact of agricultural commodity production on global rainforests.'
    const buttonText = petitionLink ? 'Sign the petition' : 'Learn more'

    const producersText = 'Companies that produce and trade palm oil, paper/pulp, rubber, timber, cattle, and soy, and have a past record or a significant risk of contributing to deforestation, land grabbing, and human rights abuses. Investing in any of these companies assigns a fund a grade of C if total producer exposure is below the threshold of 0.5%; a grade of D if below 1.5%; and a grade of F if above 1.5%.'
    const financierText = 'Financial institutions directly and indirectly involved in underwriting and lending to deforestation-risk producers and traders. Investing in any of these companies assigns a fund a grade of B (assuming there are no investments in producers).'
    const consumersText = 'Consumer goods retailers that source palm oil, paper/pulp, rubber, timber, cattle, and soy from deforestation-risk producers and traders and sell it to consumers worldwide. Investing in any of these companies assigns a fund a grade of B (assuming there are no investments in producers).'

    return (
      <div>
        {container.helmet(name, helmetTitle, url)}
        <FundName
          shareClass={shareClass}
          pathname={this.props.location.pathname}
        />
        <div styleName='snapshot-wrapper main'>
          <div styleName="snapshot">
            <Chart
              renderBox={CSSModules( renderGradeBox, Styles)}
              currency={shareClass.currency}
              invested={convert.float(shareClass.po_all_asset)}
              bankPerc={bankPerc}
              consumerPerc={consumerPerc}
              producerPerc={producerPerc}
              dffPerc={dffPerc}
              producerHoldings={producerHoldings}
              financierHoldings={financierHoldings}
              consumerHoldings={consumerHoldings}
              fHoldingsMap={fHoldingsMap}
              dffAnyAsset={fund.po_all_asset}
              netAsset={fund.fund_net_assets}
            />
            <FlaggedFund
              count={convert.int(shareClass.po_all_count)}
              weight={convert.float(shareClass.po_all_weight)}
            />
            {this.hasUssifBadge(fund.ussif) ? this.renderUssifBadge() : null}
            {this.renderEngagementStatement(shareClass)}
            <div styleName='holdings-count'>
              <div styleName='holdings-count-intro'>
                This fund contains
                <div styleName={'holdings-count-stat ' + color}>
                  &#160;
                  {format.money(convert.float(shareClass.po_all_asset), true, 
                                shareClass.currency)}
                  &#160;invested&#160;
                </div>
                 in holdings flagged for deforestation risk
              </div>
              {hasPetition ? (
                 <div styleName='company-snapshot'>
                  <div styleName='company-intro'>
                    {petitionText || defaultCopy}
                  </div>
                  <Link
                    title={
                      'Sign the petition to ask ' +
                      fund_family_name +
                      'for a No Deforestation Policy'
                    }

                    log={analytics.eventToFamilyTakeAction(name)}
                    to={petitionLink}
                    targetBlank
                  >
                    <div styleName='company-wrapper'>
                      <span styleName='company'>
                        {buttonText}<LinkIcon />
                      </span>
                    </div>
                  </Link>
                </div>
              ) : (
                <Link to={config.routes.toolkit} title='#DefundDeforestation Toolkit' greenbutton>
                  Take action<LinkIcon/>
                </Link>
              )}
            </div>
            <Row>
              <Col xs={12} sm={4} styleName='detail-producers-wrapper'>
                <div styleName={ownsProducers?'detail-producers':'detail-blank'}>
                  <img
                    styleName='detail-icon'
                    src={producersIcon}
                    alt='producers'
                  />
                  <div styleName='detail-title'>Commodity producers</div>
                  <div styleName='detail-stat'>
                    <strong>
                      {format.number(shareClass.po_producer_count)}
                    </strong> holdings
                  </div>
                  <div styleName='detail-stat'>
                    <strong>
                      {format.perc(shareClass.po_producer_weight)}
                    </strong> of assets
                  </div>
                  <div styleName='detail-stat'>
                    <strong>
                      {format.money(shareClass.po_producer_asset, true,
                                    shareClass.currency)}
                    </strong> invested
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={4} styleName='detail-banks-wrapper'>
                <div styleName={ownsBanks?'detail-banks':'detail-blank'}>
                  <img
                    styleName='detail-icon'
                    src={banksIcon}
                    alt='banks'
                  />
                  <div styleName='detail-title'>Banks and lenders</div>
                  <div styleName='detail-stat'>
                    <strong>
                      {format.number(shareClass.po_financier_count)}
                    </strong> holdings
                  </div>
                  <div styleName='detail-stat'>
                    <strong>
                      {format.perc(shareClass.po_financier_weight)}
                    </strong> of assets
                  </div>
                  <div styleName='detail-stat'>
                    <strong>
                      {format.money(shareClass.po_financier_asset, true, 
                                    shareClass.currency)}
                    </strong> invested
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={4} styleName='detail-consumers-wrapper'>
                <div styleName={ownsConsumers?'detail-consumers':'detail-blank'}>
                  <img
                    styleName='detail-icon'
                    src={consumersIcon}
                    alt='consumers'
                  />
                  <div styleName='detail-title'>Major consumer brands</div>
                  <div styleName='detail-stat'>
                    <strong>
                      {format.number(shareClass.po_consumer_count)}
                    </strong> holdings
                  </div>
                  <div styleName='detail-stat'>
                    <strong>{format.perc(shareClass.po_consumer_weight)}
                    </strong> of assets
                  </div>
                  <div styleName='detail-stat'>
                    <strong>
                      {format.money(shareClass.po_consumer_asset, true,
                                    shareClass.currency)}
                    </strong> invested
                  </div>
                </div>
              </Col>
            </Row>
            <Row styleName='details'>
              { 
                this.renderCompanies(
                  shareClass,
                  fHoldingsMap,
                  'producers',
                  'Commodity producers',
                  shareClass.po_producer_count,
                  producerHoldings,
                  this.state.producersPage,
                  producersText
                )
              }
              {
                this.renderCompanies(
                  shareClass,
                  fHoldingsMap,
                  'banks',
                  'Banks and lenders',
                  shareClass.po_financier_count,
                  financierHoldings, this.state.banksPage,
                  financierText
                )
              }
              {
                this.renderCompanies(
                  shareClass,
                  fHoldingsMap,
                  'consumers',
                  'Major consumer brands',
                  shareClass.po_consumer_count,
                  consumerHoldings,
                  this.state.consumersPage,
                  consumersText
                )
              }
            </Row>
          </div>
        </div>
        {this.renderMore(shareClass)}

        <ContainerDivs>
          <br/>
          <br/>
          <br/>
          <InlineSignup />
          <br/>
          <br/>
        </ContainerDivs>

        <IyvScorecard
          fund={fund}
          shareClass={shareClass}
        />

        { /*
        <Returns
          fund={fund}
          shareClass={shareClass}
          url={url}
        />
        */ }

        {this.renderGraphicBanner()}

        {this.renderTakeAction(shareClass)}
        
      </div>
    )
  }
}
